<template>
  <div class="q-mb-sm q-mt-sm">
    <draggable
      v-if="value.length"
      :list="value"
      itemKey="image"
      v-bind="{
        animation: 200,
        group: 'welcome',
        disabled: false,
      }"
      @change="(evt) => onDragEnd(evt, value)"
      handle=".cursor-move"
      :component-data="{
        type: 'transition-group',
        name: 'drag-area',
        class: 'q-list q-list--dense q-list--separator',
      }"
      :forceFallback="true"
      fallbackClass="dragging-item"
    >
      <template #item="{ element: answer, index }">
        <div class="q-pa-none">
          <q-item class="q-pa-none">
            <q-item-section avatar class="cursor-move">
              <div class="q-gutter-xs">
                <q-icon name="drag_indicator" color="grey" size="sm" />
                <q-btn dense round unelevated color="brand">{{ index + 1 }}</q-btn>
              </div>
            </q-item-section>
            <q-item-section>
              <q-input
                lazy-rules
                :rules="[(val) => (val && val.length > 0) || requiredRule.fieldName]"
                outlined
                v-model="answer.field_name"
                dense
                :placeholder="$t('label.common.form_liff.question')"
              />
            </q-item-section>
            <q-item-section class="col-3" @click="onHandleField(index)">
              <q-select
                outlined
                dense
                option-value="id"
                option-label="title"
                v-model="answer.option_type"
                :options="options"
                emit-value
                map-options
                @update:model-value="onSelectedFieldType"
                :rules="[(val) => (val && val.length > 0) || requiredRule.freeTextOption]"
              />
            </q-item-section>
            <q-item-section side>
              <div class="q-gutter-xs">
                <q-btn no-caps outline color="grey" size="sm" icon="add" round @click="handleAddAnswer(index)" />
                <q-btn
                  no-caps
                  outline
                  color="grey"
                  size="sm"
                  icon="remove"
                  round
                  @click="handleDeleteAnswer(index)"
                  :disabled="value.length === 1 && !isDeleteFirst"
                />
              </div>
            </q-item-section>
          </q-item>
          <div class="row q-col-gutter-sm q-mr-sm">
            <div class="col q-pb-sm">
              <q-input dense v-model="answer.contents.description" label="説明" label-color="brand-grey" />
            </div>
            <div class="row q-col-gutter-sm">
              <div class="text-caption text-brand-grey">必須</div>
              <q-toggle dense v-model="answer.is_required" color="brand" />
            </div>
          </div>

          <!-- Description input field -->
          <div class="q-mt-sm" v-if="answer.option_type === 'text'">
            <q-input
              dense
              :label="$t('label.common.form_liff.answer_text')"
              :readonly="true"
              :disable="true"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm" v-if="answer.option_type === 'textarea'">
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_textarea')"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm" v-if="answer.option_type === 'email'">
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_email')"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm" v-if="answer.option_type === 'date'">
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_date')"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm" v-if="answer.option_type === 'time'">
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_time')"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm" v-if="answer.option_type === 'prefecture'">
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_prefecture')"
              label-color="brand-grey"
            />
          </div>
          <div class="q-mt-sm row q-col-gutter-sm" v-if="answer.option_type === 'postcode'">
            <div class="row q-col-gutter-sm items-center">
              <div class="text-caption text-brand-grey">ハイフン:</div>
              <div>
                <q-btn-group>
                  <q-btn
                    size="sm"
                    :class="answer.contents.is_hyphenated ? 'btn-save' : 'btn-save-grey'"
                    label="あり"
                    @click="answer.contents.is_hyphenated = true"
                  />
                  <q-btn
                    size="sm"
                    :class="!answer.contents.is_hyphenated ? 'btn-save' : 'btn-save-grey'"
                    label="なし"
                    @click="answer.contents.is_hyphenated = false"
                  />
                </q-btn-group>
              </div>
            </div>
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_postcode')"
              label-color="brand-grey"
              class="col q-ml-sm"
            />
          </div>
          <div class="q-mt-sm row q-col-gutter-sm" v-if="answer.option_type === 'phone_number'">
            <div class="row q-col-gutter-sm items-center">
              <div class="text-caption text-brand-grey">ハイフン:</div>
              <div>
                <q-btn-group>
                  <q-btn
                    size="sm"
                    :class="answer.contents.is_hyphenated ? 'btn-save' : 'btn-save-grey'"
                    label="あり"
                    @click="answer.contents.is_hyphenated = true"
                  />
                  <q-btn
                    size="sm"
                    :class="!answer.contents.is_hyphenated ? 'btn-save' : 'btn-save-grey'"
                    label="なし"
                    @click="answer.contents.is_hyphenated = false"
                  />
                </q-btn-group>
              </div>
            </div>
            <q-input
              dense
              :readonly="true"
              :disable="true"
              :label="$t('label.common.form_liff.answer_phone_number')"
              label-color="brand-grey"
              class="col q-ml-sm"
            />
          </div>
          <div
            class="q-mt-sm"
            v-if="
              answer.option_type === 'select' || answer.option_type === 'checkbox' || answer.option_type === 'radio'
            "
          >
            <FormLIFFOption
              v-model="answer.contents.options"
              :isDeleteFirst="isDeleteFirst"
              :optionType="answer.option_type"
            />
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import draggable from 'vuedraggable'
import { Prop, Watch } from 'vue-property-decorator'
import { IFormLIFFDetail } from '@/utils/types'
import { maska } from 'maska'
import { calcOrderingDragend } from '@/utils/helpers'
import { FORM_LIFF_TYPE } from '@/utils/constants'
import FormLIFFOption from '@/components/form/FormLIFFOption.vue'

@Options({
  components: { FormLIFFOption, draggable },
  directives: { maska },
  emits: ['update:modelValue', 'update:quantityItem'],
})
export default class FormLIFFField extends Vue {
  @Prop({ default: [] })
  modelValue!: IFormLIFFDetail[]

  @Prop()
  isDeleteFirst!: boolean

  countAnswer = 0
  field_index = 0

  get value() {
    return this.modelValue
  }

  set value(value: IFormLIFFDetail[]) {
    this.$emit('update:modelValue', value)
  }

  get options() {
    return [
      {
        id: FORM_LIFF_TYPE.TEXT,
        title: this.$t('label.common.form_liff.type_text'),
      },
      {
        id: FORM_LIFF_TYPE.TEXTAREA,
        title: this.$t('label.common.form_liff.type_textarea'),
      },
      {
        id: FORM_LIFF_TYPE.EMAIL,
        title: this.$t('label.common.form_liff.type_email'),
      },
      {
        id: FORM_LIFF_TYPE.SELECT,
        title: this.$t('label.common.form_liff.type_select'),
      },
      {
        id: FORM_LIFF_TYPE.CHECKBOX,
        title: this.$t('label.common.form_liff.type_checkbox'),
      },
      {
        id: FORM_LIFF_TYPE.RADIO,
        title: this.$t('label.common.form_liff.type_radio'),
      },
      {
        id: FORM_LIFF_TYPE.DATE,
        title: this.$t('label.common.form_liff.type_date'),
      },
      {
        id: FORM_LIFF_TYPE.PREFECTURE,
        title: this.$t('label.common.form_liff.type_prefecture'),
      },
      {
        id: FORM_LIFF_TYPE.POSTCODE,
        title: this.$t('label.common.form_liff.type_postcode'),
      },
      {
        id: FORM_LIFF_TYPE.PHONE_NUMBER,
        title: this.$t('label.common.form_liff.type_phone_number'),
      },
      {
        id: FORM_LIFF_TYPE.TIME,
        title: this.$t('label.common.form_liff.type_time'),
      },
    ]
  }

  get requiredRule() {
    return {
      fieldName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.form.field_name'),
      }),
      freeTextOption: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.freetext_option_type'),
      }),
    }
  }

  async onDragEnd(evt: any, finalList: IFormLIFFDetail[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }

  onHandleField(index) {
    this.field_index = index
  }

  onSelectedFieldType() {
    const field = this.value[this.field_index]
    if (field) {
      this.handleOptionChange(field)
    }
  }

  handleOptionChange(field) {
    const existingDescription = field.contents?.description || ''

    if (field.option_type === FORM_LIFF_TYPE.TEXT) {
      field.contents = {
        short_answer: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.TEXTAREA) {
      field.contents = {
        long_answer: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.EMAIL) {
      field.contents = {
        email: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.DATE) {
      field.contents = {
        date: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.TIME) {
      field.contents = {
        time: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.PREFECTURE) {
      field.contents = {
        prefecture: '',
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.POSTCODE) {
      field.contents = {
        postcode: '',
        is_hyphenated: true,
        description: existingDescription,
      }
    } else if (field.option_type === FORM_LIFF_TYPE.PHONE_NUMBER) {
      field.contents = {
        phone_number: '',
        is_hyphenated: true,
        description: existingDescription,
      }
    } else if (
      field.option_type === FORM_LIFF_TYPE.SELECT ||
      field.option_type === FORM_LIFF_TYPE.CHECKBOX ||
      field.option_type === FORM_LIFF_TYPE.RADIO
    ) {
      field.contents = {
        options: [],
        description: existingDescription,
      }
    }
  }

  handleAddAnswer(index: number): void {
    const newAnser: IFormLIFFDetail = {
      _id: '',
      field_name: this.$t('label.common.form_liff.question'),
      option_type: FORM_LIFF_TYPE.TEXT,
      is_required: true,
      contents: {
        short_answer: '',
        description: '',
      },
    }
    if (this.value) {
      this.value.splice(index + 1, 0, newAnser)
      this.countAnswer = index + 1
    }
    if (this.value.length === 1) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  handleDeleteAnswer(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
      this.countAnswer = index - 1
    }

    if (this.value.length === 0) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  @Watch('modelValue', { immediate: true })
  showDefault() {
    if (this.value.length === 0) {
      this.handleAddAnswer(0)
    }
  }

  mounted() {
    this.showDefault()
  }
}
</script>

<style scoped lang="scss">
.q-field--with-bottom {
  padding-top: 20px;
}
.first-line .q-field--with-bottom {
  padding-top: 0;
}
.first-line {
  justify-content: flex-start !important;
}
:deep(.q-field__label) {
  font-size: 12px !important;
}
</style>
